import { NgTemplateOutlet } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, inject, ChangeDetectorRef, ElementRef, Component, ChangeDetectionStrategy, ViewEncapsulation, Input, EventEmitter, viewChildren, contentChildren, effect, booleanAttribute, forwardRef, Output, NgModule } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap, switchMap, filter, take, map, bufferCount } from 'rxjs/operators';
import * as i1 from 'ng-zorro-antd/icon';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { ReplaySubject, Subject } from 'rxjs';
import { __esDecorate, __runInitializers } from 'tslib';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { thumbMotion } from 'ng-zorro-antd/core/animation';
import * as i1$1 from 'ng-zorro-antd/core/config';
import { WithConfig } from 'ng-zorro-antd/core/config';
import { NzOutletModule } from 'ng-zorro-antd/core/outlet';
import * as i2 from '@angular/cdk/bidi';
const _c0 = ["nz-segmented-item", ""];
const _c1 = ["*"];
function NzSegmentedItemComponent_Conditional_2_ng_template_3_Template(rf, ctx) {}
function NzSegmentedItemComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵelement(1, "nz-icon", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtemplate(3, NzSegmentedItemComponent_Conditional_2_ng_template_3_Template, 0, 0, "ng-template", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const content_r3 = i0.ɵɵreference(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("nzType", ctx_r1.nzIcon);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", content_r3);
  }
}
function NzSegmentedItemComponent_Conditional_3_ng_template_0_Template(rf, ctx) {}
function NzSegmentedItemComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NzSegmentedItemComponent_Conditional_3_ng_template_0_Template, 0, 0, "ng-template", 3);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const content_r3 = i0.ɵɵreference(5);
    i0.ɵɵproperty("ngTemplateOutlet", content_r3);
  }
}
function NzSegmentedItemComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _forTrack0 = ($index, $item) => $item.value;
function NzSegmentedComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵlistener("@thumbMotion.done", function NzSegmentedComponent_Conditional_1_Template_div_animation_thumbMotion_done_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleThumbAnimationDone($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@thumbMotion", ctx_r1.animationState);
  }
}
function NzSegmentedComponent_ProjectionFallback_2_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    i0.ɵɵproperty("nzIcon", item_r3.icon)("nzValue", item_r3.value)("nzDisabled", item_r3.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r3.label);
  }
}
function NzSegmentedComponent_ProjectionFallback_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, NzSegmentedComponent_ProjectionFallback_2_For_1_Template, 2, 4, "label", 2, _forTrack0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r1.normalizedOptions);
  }
}
let NzSegmentedService = /*#__PURE__*/(() => {
  class NzSegmentedService {
    constructor() {
      this.selected$ = new ReplaySubject(1);
      this.activated$ = new ReplaySubject(1);
      this.disabled$ = new ReplaySubject(1);
      this.animationDone$ = new Subject();
    }
    ngOnDestroy() {
      this.selected$.complete();
      this.activated$.complete();
      this.disabled$.complete();
      this.animationDone$.complete();
    }
    static {
      this.ɵfac = function NzSegmentedService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzSegmentedService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: NzSegmentedService,
        factory: NzSegmentedService.ɵfac
      });
    }
  }
  return NzSegmentedService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzSegmentedItemComponent = /*#__PURE__*/(() => {
  class NzSegmentedItemComponent {
    constructor() {
      this.isChecked = false;
      this.service = inject(NzSegmentedService);
      const cdr = inject(ChangeDetectorRef);
      const elementRef = inject(ElementRef);
      this.service.selected$.pipe(tap(value => {
        this.isChecked = false;
        cdr.markForCheck();
        if (value === this.nzValue) {
          this.service.activated$.next(elementRef.nativeElement);
        }
      }), switchMap(value => this.service.animationDone$.pipe(filter(event => event.toState === 'to'), take(1), map(() => value))), filter(value => value === this.nzValue), takeUntilDestroyed()).subscribe(() => {
        this.isChecked = true;
        cdr.markForCheck();
      });
      this.service.disabled$.pipe(takeUntilDestroyed()).subscribe(disabled => {
        this.nzDisabled = disabled;
        cdr.markForCheck();
      });
    }
    handleClick() {
      if (!this.nzDisabled) {
        this.service.selected$.next(this.nzValue);
      }
    }
    static {
      this.ɵfac = function NzSegmentedItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzSegmentedItemComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NzSegmentedItemComponent,
        selectors: [["label", "nz-segmented-item", ""], ["label", "nzSegmentedItem", ""]],
        hostAttrs: [1, "ant-segmented-item"],
        hostVars: 4,
        hostBindings: function NzSegmentedItemComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function NzSegmentedItemComponent_click_HostBindingHandler() {
              return ctx.handleClick();
            });
          }
          if (rf & 2) {
            i0.ɵɵclassProp("ant-segmented-item-selected", ctx.isChecked)("ant-segmented-item-disabled", ctx.nzDisabled);
          }
        },
        inputs: {
          nzIcon: "nzIcon",
          nzValue: "nzValue",
          nzDisabled: "nzDisabled"
        },
        exportAs: ["nzSegmentedItem"],
        attrs: _c0,
        ngContentSelectors: _c1,
        decls: 6,
        vars: 2,
        consts: [["content", ""], ["type", "radio", 1, "ant-segmented-item-input", 3, "click", "checked"], [1, "ant-segmented-item-label"], [3, "ngTemplateOutlet"], [1, "ant-segmented-item-icon"], [3, "nzType"]],
        template: function NzSegmentedItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "input", 1);
            i0.ɵɵlistener("click", function NzSegmentedItemComponent_Template_input_click_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView($event.stopPropagation());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(1, "div", 2);
            i0.ɵɵtemplate(2, NzSegmentedItemComponent_Conditional_2_Template, 4, 2)(3, NzSegmentedItemComponent_Conditional_3_Template, 1, 1, null, 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, NzSegmentedItemComponent_ng_template_4_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("checked", ctx.isChecked);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.nzIcon ? 2 : 3);
          }
        },
        dependencies: [NzIconModule, i1.NzIconDirective, NgTemplateOutlet],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return NzSegmentedItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
function normalizeOptions(unnormalized) {
  return unnormalized.map(item => {
    if (typeof item === 'string' || typeof item === 'number') {
      return {
        label: `${item}`,
        value: item
      };
    }
    return item;
  });
}
const NZ_CONFIG_MODULE_NAME = 'segmented';
let NzSegmentedComponent = (() => {
  let _nzSize_decorators;
  let _nzSize_initializers = [];
  let _nzSize_extraInitializers = [];
  return class NzSegmentedComponent {
    static {
      const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
      _nzSize_decorators = [WithConfig()];
      __esDecorate(null, null, _nzSize_decorators, {
        kind: "field",
        name: "nzSize",
        static: false,
        private: false,
        access: {
          has: obj => "nzSize" in obj,
          get: obj => obj.nzSize,
          set: (obj, value) => {
            obj.nzSize = value;
          }
        },
        metadata: _metadata
      }, _nzSize_initializers, _nzSize_extraInitializers);
      if (_metadata) Object.defineProperty(this, Symbol.metadata, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: _metadata
      });
    }
    constructor(nzConfigService, cdr, directionality) {
      this.nzConfigService = nzConfigService;
      this.cdr = cdr;
      this.directionality = directionality;
      this._nzModuleName = NZ_CONFIG_MODULE_NAME;
      this.nzBlock = false;
      this.nzDisabled = false;
      this.nzOptions = [];
      this.nzSize = __runInitializers(this, _nzSize_initializers, 'default');
      this.nzValueChange = (__runInitializers(this, _nzSize_extraInitializers), new EventEmitter());
      this.viewItemCmps = viewChildren(NzSegmentedItemComponent);
      this.contentItemCmps = contentChildren(NzSegmentedItemComponent);
      this.dir = 'ltr';
      this.animationState = {
        value: 'to',
        params: thumbAnimationParamsOf()
      };
      this.normalizedOptions = [];
      this.onChange = () => {};
      this.onTouched = () => {};
      this.service = inject(NzSegmentedService);
      this.directionality.change.pipe(takeUntilDestroyed()).subscribe(direction => {
        this.dir = direction;
        this.cdr.markForCheck();
      });
      this.service.selected$.pipe(takeUntilDestroyed()).subscribe(value => {
        this.value = value;
        this.nzValueChange.emit(value);
        this.onChange(value);
      });
      this.service.activated$.pipe(bufferCount(2, 1), takeUntilDestroyed()).subscribe(elements => {
        this.animationState = {
          value: 'from',
          params: thumbAnimationParamsOf(elements[0])
        };
        this.cdr.detectChanges();
        this.animationState = {
          value: 'to',
          params: thumbAnimationParamsOf(elements[1])
        };
        this.cdr.detectChanges();
      });
      effect(() => {
        const itemCmps = this.viewItemCmps().concat(this.contentItemCmps());
        if (!itemCmps.length) {
          return;
        }
        if (this.value === null || this.value === undefined || !itemCmps.some(item => item.nzValue === this.value) // handle value not in options
        ) {
          this.service.selected$.next(itemCmps[0].nzValue);
        }
      });
    }
    ngOnChanges(changes) {
      const {
        nzOptions,
        nzDisabled
      } = changes;
      if (nzOptions) {
        this.normalizedOptions = normalizeOptions(nzOptions.currentValue);
      }
      if (nzDisabled) {
        this.service.disabled$.next(nzDisabled.currentValue);
      }
    }
    handleThumbAnimationDone(event) {
      if (event.toState === 'to') {
        this.animationState = null;
      }
      this.service.animationDone$.next(event);
    }
    writeValue(value) {
      if (value === null || value === undefined) return;
      this.service.selected$.next(value);
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    static {
      this.ɵfac = function NzSegmentedComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzSegmentedComponent)(i0.ɵɵdirectiveInject(i1$1.NzConfigService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.Directionality));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NzSegmentedComponent,
        selectors: [["nz-segmented"]],
        contentQueries: function NzSegmentedComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuerySignal(dirIndex, ctx.contentItemCmps, NzSegmentedItemComponent, 4);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        viewQuery: function NzSegmentedComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.viewItemCmps, NzSegmentedItemComponent, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        hostAttrs: [1, "ant-segmented"],
        hostVars: 10,
        hostBindings: function NzSegmentedComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("ant-segmented-disabled", ctx.nzDisabled)("ant-segmented-rtl", ctx.dir === "rtl")("ant-segmented-lg", ctx.nzSize === "large")("ant-segmented-sm", ctx.nzSize === "small")("ant-segmented-block", ctx.nzBlock);
          }
        },
        inputs: {
          nzBlock: [2, "nzBlock", "nzBlock", booleanAttribute],
          nzDisabled: [2, "nzDisabled", "nzDisabled", booleanAttribute],
          nzOptions: "nzOptions",
          nzSize: "nzSize"
        },
        outputs: {
          nzValueChange: "nzValueChange"
        },
        exportAs: ["nzSegmented"],
        features: [i0.ɵɵProvidersFeature([NzSegmentedService, {
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => NzSegmentedComponent),
          multi: true
        }]), i0.ɵɵInputTransformsFeature, i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c1,
        decls: 4,
        vars: 1,
        consts: [[1, "ant-segmented-group"], [1, "ant-segmented-thumb", "ant-segmented-thumb-motion"], ["nz-segmented-item", "", 3, "nzIcon", "nzValue", "nzDisabled"]],
        template: function NzSegmentedComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, NzSegmentedComponent_Conditional_1_Template, 1, 1, "div", 1);
            i0.ɵɵprojection(2, 0, null, NzSegmentedComponent_ProjectionFallback_2_Template, 2, 0);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.animationState ? 1 : -1);
          }
        },
        dependencies: [NzIconModule, NzOutletModule, NzSegmentedItemComponent],
        encapsulation: 2,
        data: {
          animation: [thumbMotion]
        },
        changeDetection: 0
      });
    }
  };
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function thumbAnimationParamsOf(element) {
  return {
    transform: element?.offsetLeft ?? 0,
    width: element?.clientWidth ?? 0
  };
}

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzSegmentedModule = /*#__PURE__*/(() => {
  class NzSegmentedModule {
    static {
      this.ɵfac = function NzSegmentedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzSegmentedModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NzSegmentedModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [NzSegmentedComponent, NzSegmentedItemComponent]
      });
    }
  }
  return NzSegmentedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NzSegmentedComponent, NzSegmentedItemComponent, NzSegmentedModule, normalizeOptions };
